import { Dispatch, SetStateAction } from 'react';
import { ace_index } from '@axo/shared/data-access/types';
import { FilterSelect } from '../FilterSelect';
import { areObjectsDifferent } from '../../utils/compareObjects';
import { setPageNumber } from '../SearchResults';

interface Props {
  query: ace_index.FindInput;
  setQuery: Dispatch<SetStateAction<ace_index.FindInput>>;
  editable?: boolean;
}

export function NumAnsweredCallsBetween({
  query,
  setQuery,
  editable = false,
}: Props) {
  const state = getState(query);
  const value =
    options.find((option) => !areObjectsDifferent(state, option.value)) ??
    options[0];

  return (
    <FilterSelect
      items={options}
      onSelect={(option) => setQuery(setState(option.value))}
      stringify={(option) => option.label}
      value={value}
      label="Have we talked to the customer"
      description="Filter applications by how many answered calls have been made"
      disabled={!editable}
    />
  );
}

const options: { label: string; value: Value }[] = [
  {
    label: 'All',
    value: undefined,
  },
  {
    label: 'Yes',
    value: {
      From: 1,
    },
  },
  {
    label: 'No',
    value: {
      From: 0,
      To: 1,
    },
  },
];

function setState(range: Value): SetStateAction<ace_index.FindInput> {
  return (query) => ({
    ...setPageNumber(1)(query),
    SummaryNumAnsweredCalls: range,
  });
}

function getState(query: ace_index.FindInput) {
  return query.SummaryNumAnsweredCalls;
}

type Value = ace_index.FindInput['SummaryNumAnsweredCalls'];
